import useBillingUsage from './useBillingUsage';

export default function useTierFeatures() {
    const { data, isLoading } = useBillingUsage();
    const tier = data?.tier ?? null;
    return {
        tier,
        maxMembers: data?.maxMembers ?? null,
        quotePdfEnabled: data?.quotePdfEnabled ?? false,
        aiInsightsEnabled: tier === 'business',
        // Accounting integrations (Xero/QuickBooks/Sage) — Pro & Business only.
        accountingEnabled: data?.accountingEnabled ?? false,
        isLoading,
    };
}
